<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <component-input
                @keyupEnter="apply"
                label="Логин:"
                v-model="currFilters.userName"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <component-input
                @keyupEnter="apply"
                label="E-mail:"
                v-model="currFilters.email"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <component-input
                @keyupEnter="apply"
                label="Телефон:"
                v-model="currFilters.phoneNumber"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Роли:</label>
              <Select2
                :options="roleList"
                placeholder="Не выбрано"
                multiple="multiple"
                :settings="{ multiple: true, language: 'ru' }"
                v-model="currFilters.roleIds"
                style="width: 100%"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Организация</label>
              <Select2
                class="select2"
                placeholder="Не выбрано"
                :options="organizations"
                v-model="currFilters.organizationId"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <component-input
                @keyupEnter="apply"
                label="Фамилия:"
                v-model="currFilters.surname"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <component-input
                @keyupEnter="apply"
                label="Имя:"
                v-model="currFilters.name"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <component-input
                @keyupEnter="apply"
                label="Отчество:"
                v-model="currFilters.patronymic"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Заблокирован:</label>
              <select
                @keyup.enter="apply"
                class="form-control"
                v-model="currFilters.isDisabled"
              >
                <option v-for="item in yesNoList" :value="item.id">
                  {{ item.text }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer d-flex justify-content-between">
        <button-component class="col-6" @click="apply">
          Применить
        </button-component>
        <button-component class="col-6" kind="secondary" @click="reset">
          Сбросить
        </button-component>
      </div>
    </div>
  </div>
</template>

<script>
import Constants from "../../../common/constants";
import RoleApi from "../api/roles";
import OrgAPI from "../../organization/api/organizations";
import ComponentInput from "@/common/components/ComponentInput";
import ButtonComponent from "@/common/ui/ButtonComponent";

function orgCompare(a, b) {
  if (a.text > b.text) {
    return 1;
  }
  if (a.text < b.text) {
    return -1;
  }
  return 0;
}

export default {
  name: "UsersFilter",
  components: { ButtonComponent, ComponentInput },
  props: {
    filters: Object,
  },
  data() {
    return {
      currFilters: this.filters,
      yesNoList: Constants.yesNoList,
      roleList: [],
      organizations: [
        {
          id: 0,
          text: Constants.emptySelectOptionText,
          selected: false,
        },
      ],
    };
  },
  created() {
    RoleApi.search({ pageNumber: 1, pageSize: -1 }).then((response) => {
      this.roleList = response.data.items.map((item) => ({
        id: item.id,
        text: item.name,
      }));
    });
    this.loadOrganizationList();
  },
  methods: {
    loadOrganizationList() {
      this.organizations = [];
      OrgAPI.search({ pageNumber: 1, pageSize: -1, isOrgan: false }).then(
        (response) => {
          var orglist = response.data.items.map((x) => {
            return { id: x.id, text: x.name };
          });
          orglist.forEach((el) => {
            this.organizations.push(el);
          });
          this.organizations.sort(orgCompare);
        }
      );
      OrgAPI.search({ pageNumber: 1, pageSize: -1, isOrgan: true }).then(
        (response) => {
          var orglist = response.data.items.map((x) => {
            return { id: x.id, text: x.name ? x.name : x.nameFull };
          });
          orglist.forEach((el) => {
            this.organizations.push(el);
          });
          this.organizations.sort(orgCompare);
        }
      );
    },
    apply() {
      const filters = Object.assign({}, this.currFilters);
      this.$emit("apply", filters);
    },
    reset() {
      this.currFilters = {
        userName: "",
        email: "",
        surname: "",
        name: "",
        patronymic: "",
        phoneNumber: "",
        roleIds: [],
        isDisabled: null,
        organizationId: 0,
      };
      const filters = Object.assign({}, this.currFilters);
      this.$emit("reset", filters);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "src/assets/theme/default/colors";

.form-group {
  label {
    font-weight: 400 !important;
    color: $gray-dark;
    font-size: 16px;
  }
}

.card-footer {
  gap: 10px;
  align-items: center;
  justify-content: space-between;
}
</style>
